import { Languages, Share2, Handshake } from "lucide-react";
import { useI18n } from "@/i18n/LanguageContext";
import { Reveal } from "@/components/site/Reveal";
import { SectionHeading } from "@/components/site/SectionHeading";

const icons = [Languages, Share2, Handshake];

export const VaaniSection = () => {
  const { t } = useI18n();
  const v = t.vaani;
  return (
    <section className="relative overflow-hidden bg-gradient-navy">
      <div className="absolute inset-0 bg-grid-light opacity-30" aria-hidden="true" />
      <div
        className="absolute -right-24 top-1/2 h-80 w-80 -translate-y-1/2 rounded-full opacity-20 blur-3xl"
        style={{ background: "radial-gradient(circle, hsl(var(--gold)) 0%, transparent 70%)" }}
        aria-hidden="true"
      />
      <div className="container-site section-pad relative py-20 md:py-24">
        <SectionHeading light eyebrow={v.eyebrow} title={v.title} description={v.desc} />
        <div className="mt-12 grid gap-5 md:grid-cols-3">
          {v.pillars.map((pillar, i) => {
            const Icon = icons[i];
            return (
              <Reveal
                key={i}
                delay={i * 0.08}
                className="flex h-full flex-col rounded-xl border border-primary-foreground/12 bg-primary-foreground/[0.04] p-6 backdrop-blur-sm transition-colors duration-300 hover:border-gold/40"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-gold/15 text-gold-soft">
                  <Icon className="h-5 w-5" />
                </span>
                <h3 className="font-display mt-5 text-lg text-primary-foreground">{pillar.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-primary-foreground/65">{pillar.body}</p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
